import $ from '@vaersaagod/tools/Dom';

export default el => {
    const dom = $(el);
    const wrapper = dom.find('[data-wrapper]').get(0);
    const filter = dom.find('[data-filter]');
    const hasFilter = filter.length > 0;
    const items = dom.find('[data-location]');

    const filterItems = val => {
        const oldHeight = dom.height();
        const toHide = val === 'all' ? [] : items.filter(item => $(item).data('location') !== val).nodes;

        TweenMax.killChildTweensOf(el);

        new TimelineMax()
            .set(wrapper, { height: oldHeight })
            .to(items.nodes, 0.5, { opacity: 0, clearProps: 'display' })
            .set(toHide, { display: 'none' })
            .set(wrapper, { height: 'auto' })
            .from(wrapper, 0.5, { height: oldHeight, ease: 'Quad.easeOut', immediateRender: false })
            .to(items.nodes, 0.5, { opacity: 1 }, '-=0.25');
    };

    const onChange = () => {
        filterItems(filter.find('input:checked').val());
    };

    const init = () => {
        if (hasFilter) {
            filter.on('change', 'input', onChange);
        }
    };

    const destroy = () => {
        TweenMax.killChildTweensOf(el);
        filter.off('change');
    };

    return {
        init,
        destroy
    };
};



// WEBPACK FOOTER //
// ./src/js/components/List.js